import VideoInVideo from './videoInVideo.ui';

export default VideoInVideo;
